import { observable, ObservableMap } from 'mobx'

export default class IdObjectStore {
  @observable idObjectMap = new ObservableMap()
  constructor(public keyField: string) {}

  clearAll() {
    this.idObjectMap.replace(new Map())
  }
}
